/**
 * 이름: insertComma
 * 설명: 파라미터로 디렉티브가 지정된 컴포넌트의 요소를 전달 받은 후 천단위로 콤마를 추가한다.
 */
function insertComma (el, activeDirective = true) {
  if (!activeDirective) {
    return
  }

  const numberVal = typeof el.value === 'string' && Number(el.value.replace(/[^0-9]/gi, ''))

  if (typeof numberVal === 'number' && !isNaN(numberVal)) {
    el.value = numberVal.toLocaleString()
  }
}

export default {
  name: 'comma',
  /**
   * 이름: inserted (Hook)
   * 설명: comma 디렉티브가 지정된 컴포넌트가 부모 요소에 Insert 되었을때 호출한다.
   */
  inserted (el, binding) {
    insertComma(el, binding.value)
  },
  /**
   * 이름: componentUpdated (Hook)
   * 설명: comma 디렉티브가 지정된 컴포넌트의 상태가 업데이트 되었을때 호출한다.
   */
  componentUpdated (el, binding) {
    insertComma(el, binding.value)
  }
}
